<div class="card card-accent-primary shadowed">
  <div class="card-header">
    <strong>{{ visuals.selectDocType }}</strong>
  </div>
  <div class="card-block">
    <div class="form-group">
      <div class="col-md-12 input-group">
        <select
          class="form-control"
          [(ngModel)]="selectedType"
          (change)="onCategoryChange()"
          #selectField
        >
          <option value="" selected disabled>{{ visuals.selectDocType }}</option>
          <option *ngFor="let lkp of lookUpArray" [ngValue]="lkp.lkupTable + '-' + lkp.lkupCol">
            {{ lkp?.val | filterList:typesList }}
          </option>
        </select>
      </div>
    </div>
  </div>
</div>

<div *ngIf="loading" class="dataLoader"></div>

<ul *ngIf="!loading " class="list-group" style="overflow-y: scroll;max-height:700px">
  <li
    style="margin-bottom: 5px;"
    class="list-group-item"
    *ngFor="let pk of legalDocument;let i=index"
  >
    {{ pk?.id | filterList:legalDocument }}
    <i
      *ngIf="!viewRole"
      style="position: absolute;right: 55px;"
      (click)="openFormModal('edit',pk.id);"
      class="mdi md-16 mdi-pencil mb-12 text-info"
    ></i>
    <i
      *ngIf="!viewRole"
      style="position: absolute;right: 15px;"
      (click)="confirmDeleteModal.show()"
      class="mdi md-16 mdi-trash-can-outline text-danger"
    ></i>
    <div
      bsModal
      #confirmDeleteModal="bs-modal"
      [config]="{backdrop: 'static'}"
      class="modal fade"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myLargeModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title pull-left"></h4>
            <button
              type="button"
              class="close pull-right"
              aria-label="Close"
              (click)="confirmDeleteModal.hide()"
            >
              <span aria-hidden="true"><i class="fa fa-close"></i></span>
            </button>
          </div>
          <div class="modal-body">
            <h4 style="text-align: center;">{{visuals.confDelType}}</h4>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-danger"
              data-dismiss="modal"
              (click)="confirmDeleteModal.hide()"
            >
              {{visuals.cancel}}
            </button>
            <button
              type="button"
              class="btn btn-success"
              data-dismiss="modal"
              (click)="deleteDoc(pk.id)"
            >
              {{visuals.submit}}
            </button>
          </div>
        </div>
      </div>
    </div>
  </li>
</ul>

<div class="float-right" *ngIf="selectedType && !viewRole" (click)="openFormModal('create', null);">
  <i class="mdi md-64 mdi-plus-circle text-primary"></i>
</div>

<div
  bsModal
  #confirmUpdateModal="bs-modal"
  [config]="{backdrop: 'static'}"
  class="modal fade"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myLargeModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title pull-left"></h4>
        <button
          type="button"
          class="close pull-right"
          aria-label="Close"
          (click)="confirmUpdateExisting('No')"
        >
          <span aria-hidden="true"><i class="fa fa-close"></i></span>
        </button>
      </div>
      <div class="modal-body">
        <h4 style="text-align: center;">{{visuals.alreadyExist}}</h4>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-danger"
          data-dismiss="modal"
          (click)="confirmUpdateExisting('No')"
        >
          {{visuals.cancel}}
        </button>
        <button
          type="button"
          class="btn btn-success"
          data-dismiss="modal"
          (click)="confirmUpdateExisting('Yes')"
        >
          {{visuals.submit}}
        </button>
      </div>
    </div>
  </div>
</div>

<div
  bsModal
  #formModal="bs-modal"
  [config]="{backdrop: 'static'}"
  class="modal fade"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myLargeModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <form *ngIf="descriptionForm" [formGroup]="descriptionForm" (ngSubmit)="saveType()">
        <div class="modal-header">
          <h4 class="modal-title pull-left"></h4>
          <button
            type="button"
            class="close pull-right"
            aria-label="Close"
            (click)="formModal.hide(); "
          >
            <span aria-hidden="true"><i class="fa fa-close"></i></span>
          </button>
        </div>
        <div class="modal-body">
          <div class="card card-accent-primary shadowed">
            <div class="card-header">
              <strong>{{ action == 'edit' ? visuals.updateTitle : visuals.title}}</strong>
            </div>
            <div class="card-block">
              <div class="form-group">
                <label class="input-required" for="name">{{visuals.shortDescr}}</label>
                <input
                  *ngIf="(selectedType != 'REG_COMPANY-S_SUB_LOB' || action === 'edit')"
                  type="text"
                  [attr.disabled]="action == 'edit' ? true : null"
                  class="form-control"
                  formControlName="val"
                />
                <select
                  class="form-control"
                  *ngIf="(selectedType === 'REG_COMPANY-S_SUB_LOB' && action != 'edit')"
                  formControlName="val"
                  [ngClass]="{'errorField':isSubmitted && descriptionForm.controls['val'].errors?.required}"
                >
                  <option></option>
                  <option *ngFor="let subLob of subLobList" [value]="subLob.id">
                    {{subLob.text}}
                  </option>
                </select>

                <div class="error" *ngIf="descriptionForm.controls['val'].errors?.maxlength">
                  {{genericVisuals.maxCharLength + valMaxLength}}
                </div>

                <div
                  class="error"
                  *ngIf="isSubmitted && descriptionForm.controls['val'].errors?.required"
                >
                  {{genericVisuals.required}}
                </div>
              </div>

              <div *ngIf="lang2Enabled" class="form-group">
                <label for="name" class="input-required">{{visuals.engDescr}}</label>
                <input
                  [ngClass]="{'errorField':isSubmitted && descriptionForm.controls['engDesc'].errors?.required}"
                  type="text"
                  class="form-control"
                  formControlName="engDesc"
                />
                <div class="error" *ngIf="descriptionForm.controls['engDesc'].errors?.maxlength">
                  {{genericVisuals.maxCharLength}} 200
                </div>
                <div
                  class="error"
                  *ngIf="isSubmitted && descriptionForm.controls['engDesc'].errors?.required"
                >
                  {{genericVisuals.required}}
                </div>
              </div>

              <div *ngIf="lang1Enabled" class="form-group">
                <label for="name" class="input-required">{{visuals.grDescr}}</label>
                <input
                  [ngClass]="{'errorField':isSubmitted && descriptionForm.controls['grDesc'].errors?.required}"
                  type="text"
                  class="form-control"
                  formControlName="grDesc"
                  [style.direction]="lang1IsRightToLeft ? 'RTL' : null"
                />
                <div class="error" *ngIf="descriptionForm.controls['grDesc'].errors?.maxlength">
                  {{genericVisuals.maxCharLength}} 200
                </div>
                <div
                  class="error"
                  *ngIf="isSubmitted && descriptionForm.controls['grDesc'].errors?.required"
                >
                  {{genericVisuals.required}}
                </div>
              </div>

              <div *ngIf="lookUpTable == 'REGCMP_DOCUMENT'" class="form-group">
                <label class="input-required" for="name">{{visuals.groupDescr}}</label>
                <select
                  (change)="onGroupChange($event)"
                  class="form-control"
                  [formControl]="descriptionForm.controls['group']"
                >
                  <option *ngFor="let grp of groups;" [value]="grp.docType">
                    {{ grp?.docType | filterList:groupsList }}
                  </option>
                </select>
                <div
                  class="error"
                  *ngIf="isSubmitted && descriptionForm.controls['group'].errors?.required"
                >
                  {{genericVisuals.required}}
                </div>
              </div>

              <div *ngIf="lookUpTable == 'REGCMP_DOCUMENT' && showSubGroupField" class="form-group">
                <label class="input-required" for="name">{{visuals.docSafe}}</label>
                <select class="form-control" [formControl]="descriptionForm.controls['docSafe']">
                  <option value="" disabled selected hidden></option>
                  <option *ngFor="let docSf of docSafeList;" [value]="docSf?.docSafe">
                    {{ docSf?.docSafe }}
                  </option>
                </select>
                <div
                  class="error"
                  *ngIf="isSubmitted && descriptionForm.controls['docSafe'].errors?.required"
                >
                  {{genericVisuals.required}}
                </div>
              </div>

              <div *ngIf="lookUpTable == 'REGCMP_DOCUMENT'" class="form-group">
                <label class="input-required" for="name">{{visuals.isOptional}}</label>
                <select class="form-control" [formControl]="descriptionForm.controls['isOptional']">
                  <option *ngFor="let option of yesNoList;" [value]="option.id">
                    {{ option?.text }}
                  </option>
                </select>
                <div
                  class="error"
                  *ngIf="isSubmitted && descriptionForm.controls['isOptional'].errors?.required"
                >
                  {{genericVisuals.required}}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-danger"
            data-dismiss="modal"
            (click)="formModal.hide(); descriptionForm.reset()"
          >
            {{visuals.cancel}}
          </button>
          <button type="submit" class="btn btn-success" data-dismiss="modal">
            {{visuals.submit}}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
